module.exports = __webpack_public_path__ + "static/whitestartaggie-fd2d84c04e5c3422e94f20f00dd3e21c.png";